import { render } from "./EventsEditorModal.vue?vue&type=template&id=71a8ce96&scoped=true"
import script from "./EventsEditorModal.vue?vue&type=script&lang=ts"
export * from "./EventsEditorModal.vue?vue&type=script&lang=ts"

import "./EventsEditorModal.vue?vue&type=style&index=0&id=71a8ce96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71a8ce96"

export default script